import { combineReducers } from 'redux'

import createByIdReducer from '../entity/byId'
import createAllIdsReducer from '../entity/allIds'
import createIndexIdsReducer from '../entity/indexIds'
import createMetaReducer from '../entity/meta'
import createVehicleMetaReducer from '../entity/vehicleMeta'

export const allMakesModels = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_VEHICLE_FACETS_SUCCESS':
      return {
        ...state,
        make: action.makes,
        models: action.models,
      }
    default:
      return state
  }
}

export default combineReducers({
  byId: createByIdReducer('vehicle'),
  allIds: createAllIdsReducer('vehicle'),
  indexIds: createIndexIdsReducer('vehicle'),
  meta: createMetaReducer('vehicle'),
  vehicleMeta: createVehicleMetaReducer('vehicle'),
})

//Selectors

export const selectVehicle = (state, id) => {
  if (id) {
    return state.byId[id] || {}
  } else {
    return {}
  }
}

export const selectVehicleIndex = (state) => {
  return state.indexIds.map((id) => state.byId[id]) || []
}

export const selectVehicleMeta = (state) => {
  return state.meta || {}
}

export const selectVehicleMakeModelMeta = (state) => {
  return state.vehicleMeta || {}
}

export const selectAllVehicleMakes = (state) => {
  return state.make || []
}

export const selectAllVehicleModels = (state) => {
  return state.models || []
}
